import { services, contactTimes } from '@/data/contact'
import { emailSchema } from '@/utils/validators'

export const emptyContactForm = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  service: '',
  preferredTime: '',
  message: '',
}

export type ContactFormData = typeof emptyContactForm
export type ContactFormErrors = Partial<Record<keyof ContactFormData, string>>

export const contactFieldLimits = {
  firstName: 100,
  lastName: 100,
  email: 254,
  phone: 40,
  message: 5000,
} as const

export function validateContactForm(data: ContactFormData): ContactFormErrors {
  const errors: ContactFormErrors = {}

  if (!data.firstName.trim()) errors.firstName = 'Please enter your first name.'
  if (!data.lastName.trim()) errors.lastName = 'Please enter your last name.'
  if (!data.email.trim()) {
    errors.email = 'Please enter your email address.'
  } else if (!emailSchema.safeParse(data.email).success) {
    errors.email = 'Please enter a valid email address.'
  }
  if (!data.message.trim()) errors.message = 'Please enter your message.'

  const phone = data.phone.trim()
  if (phone && (!/^[+\d\s().-]+$/.test(phone) || phone.replace(/\D/g, '').length < 7)) {
    errors.phone = 'Please enter a valid phone number, or leave this field empty.'
  }

  for (const field of Object.keys(contactFieldLimits) as (keyof typeof contactFieldLimits)[]) {
    if (data[field].length > contactFieldLimits[field]) {
      errors[field] = `Please use ${contactFieldLimits[field]} characters or fewer.`
    }
  }

  if (!data.service || !services.some(({ value }) => value === data.service)) {
    errors.service = 'Please select a service from the list.'
  }
  if (!contactTimes.some(({ value }) => value === data.preferredTime)) {
    errors.preferredTime = 'Please select a contact time from the list.'
  }

  return errors
}
